import { useCallback } from "react";
import {
    Box,
    Button,
    IconButton,
    TableBody,
    TableCell,
    TableRow,
    Typography,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { Template } from "../../../../types/template";

const rowsPerPage = 5;

type RowsType = {
    data: Template[];
    status: string;
    page: number;
    showAlert: (v: number) => void;
    showEditButton: boolean;
    handleOpenTemplateEditor: (v: Template) => void;
}

const Rows = ({ data, status, page, showAlert, showEditButton, handleOpenTemplateEditor }: RowsType) => {
    const emptyMessage = `No ${status} templates.`;

    const pageData = useCallback(() => {
        return data.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    }, [data, page]);

    return (
        <TableBody>
            {data.length === 0 ? (
                <TableRow key={0} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell component="th" scope="row">
                        <Typography>{emptyMessage}</Typography>
                    </TableCell>
                </TableRow>
            ) : (
                pageData().map((row) =>
                    <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell component="th">
                            <Box display="flex" alignItems="center" gap={1}>
                                {showEditButton &&
                                    <IconButton onClick={() => { handleOpenTemplateEditor(row) }}><Edit /></IconButton>
                                }
                                <Typography>{row.name}</Typography>
                            </Box>
                        </TableCell>
                        <TableCell align="right">
                            <Typography>{row.contentType}</Typography>
                        </TableCell>
                        <TableCell align="right">
                            <Typography>{row.transitionType}</Typography>
                        </TableCell>
                        <TableCell align="right">
                            <Typography>{row.orientation}</Typography>
                        </TableCell>
                        <TableCell align="right">
                            <Typography>{row.businessName}</Typography>
                        </TableCell>
                        {status === "active" &&
                             <TableCell align="right">
                                <Typography>{row.getUpdatedAtString()}</Typography>
                            </TableCell>
                        }
                        {status === "archived" &&
                            <TableCell align="right">
                                <Typography>{row.getArchivedAtString()}</Typography>
                            </TableCell>
                        }
                        {status === "active" &&
                            <TableCell align="right">
                                <Button
                                    variant="outlined"
                                    onClick={() => showAlert(row.id)}
                                >
                                    Archive
                                </Button>
                            </TableCell>
                        }
                    </TableRow>
                )
            )}
        </TableBody>
    )
}

export default Rows;
